// frontend/src/components/loading/LazyAdminPageSkeleton.js
//
// The admin page skeleton (AdminPageSkeleton.js), loaded on demand - the
// fallback appRoutes.js gives /admin and /admin/users/:userId while their page
// chunk downloads (inside PageBodySuspense, under the real navbar).
//
// WHY LAZY. A fallback is normally eager - it is what shows WHILE a chunk
// loads. But the admin skeleton (with AdminTabSkeleton and
// AdminStatisticsSkeleton behind it) serves two admin-only routes, and a
// static import from the route table put it in the main chunk every visitor
// downloads - anonymous homepage visitors included. So it gets its own chunk,
// and ProtectedRoute starts that chunk as soon as it knows the signed-in user
// is an admin (components/ProtectedRoute.js), so normally it is in long
// before the admin opens an admin page and renders with no wait at all
// (lazyWithPreload renders a loaded module directly). Settings' skeleton is
// split the same way (LazySettingsPageSkeleton.js).
//
// How it loads, what it shows meanwhile (nothing), and why a failed chunk
// renders nothing and is retried on the next mount instead of breaking the
// page: utils/lazySkeleton.js, shared with LazySettingsPageSkeleton.js.

import lazySkeleton from "../../utils/lazySkeleton";

/**
 * AdminPageSkeleton, code-split. Takes exactly AdminPageSkeleton's props and
 * forwards all of them (`variant`, the language, anything added later).
 * `.preload()` starts (or joins) the chunk download and never rejects.
 *
 * @type {React.ComponentType & {preload: () => Promise<unknown>}}
 */
const LazyAdminPageSkeleton = lazySkeleton(() => import("./AdminPageSkeleton"));

export default LazyAdminPageSkeleton;
